import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import styled from 'styled-components';

import cx from 'classnames';

import HeaderLogo from '../AppLogo';
import { CustomNav, SettingsNav } from '../AppNav/NavItems';

import useTranslation from '@hooks/useTranslation';
import UserBox from './Components/UserBox';
import NotificationDots from './Components/NotificationDots';
import FullscreenDot from './Components/FullScreenDot';
import SettingDot from './Components/SettingDot';

import HEADER_MAIN_LOGO from '../../../assets/images/header_main_logo.svg';
import HEADER_SUB_LOGO from '../../../assets/images/header_sub_logo.svg';

const initialGnbMenu = { menuName: '', subMenuName: '' };

const Header = () => {
    const t = useTranslation('Menu');
    const location = useLocation();

    const match = useRouteMatch(['/dashboards/:menuNum([0-9]+)', '/dashboards/edit/:menuNum([0-9]+)']);
    const realtimeCoalStorageMatch = useRouteMatch('/dashboard/status/:targetNum([0-9]+)');
    const filterMatch = useRouteMatch(['/filter/:menuNum([0-9]+)', '/filter/create']);
    const menuRightsMatch = useRouteMatch('/setting/menu');

    const [gnbMenu, setGnbMenu] = useState(initialGnbMenu);
    const { headerBackgroundColor, enableMobileMenuSmall } = useSelector(state => state.ThemeOptions);
    const { bookmarkedMenu } = useSelector(state => state.CustomMenu);

    useEffect(() => {
        let pathname = location.pathname;
        if (pathname.includes('/dashboards/edit/')) {
            pathname = pathname.replace('/edit', '');
        }

        if (filterMatch) {
            setGnbMenu({
                menuName: 'Filters',
                subMenuName: 'Filter Detail',
            });
        } else if (menuRightsMatch) {
            setGnbMenu({
                menuName: 'Settings',
                subMenuName: SettingsNav.find(v => v.id === 'menuRights').label,
            });
        } else if (realtimeCoalStorageMatch) {
            setGnbMenu({
                menuName: 'Dashboards',
                subMenuName: 'Real-time Airtight Status',
            });
        } else {
            let foundGnbMenu = null;
            if (match && match.params.menuNum) {
                const menuNum = Number(match.params.menuNum);
                bookmarkedMenu.forEach(menu => {
                    if (menu.menuNum === menuNum) {
                        foundGnbMenu = menu;
                        setGnbMenu({
                            menuName: 'Dashboards',
                            subMenuName: menu.menuName,
                            isCustom: true,
                        });
                        return false;
                    }
                });
            } else {
                CustomNav.forEach(menu => {
                    if (menu.content) {
                        const subMenu = menu.content;
                        const foundMenu = subMenu.find(menu => menu.to === `#${pathname}`);
                        if (foundMenu) {
                            foundGnbMenu = foundMenu;
                            setGnbMenu({
                                menuName: menu.label,
                                subMenuName: foundMenu.label,
                                isCustom:
                                    foundMenu.id &&
                                    (foundMenu.id.includes('customDashboard_') || foundMenu.id.includes('filterMenu_')),
                            });
                            return false;
                        }
                    }
                });
            }
            if (!foundGnbMenu) {
                setGnbMenu(initialGnbMenu);
            }
        }
    }, [location, CustomNav, bookmarkedMenu]);

    return (
        <ReactCSSTransitionGroup
            component="div"
            className={cx('app-header', headerBackgroundColor)}
            transitionName="HeaderAnimation"
            transitionAppear={true}
            transitionAppearTimeout={1500}
            transitionEnter={false}
            transitionLeave={false}
        >
            {/*<HeaderLogo />*/}

            <div className="d-flex mx-3 gap-3">
                <img src={HEADER_MAIN_LOGO} alt="main logo" />
                <MainDesc>
                    {t('Safety Management System for Remainers in Underground Vertical Area', 'SmartSafe')}
                </MainDesc>
            </div>

            <div className={cx('app-header__content', { 'header-mobile-open': enableMobileMenuSmall })}>
                {/*<div className="app-header-left">*/}
                {/*    <span className={'menu-sub'}>*/}
                {/*        {gnbMenu.menuName ? (gnbMenu.isCustom ? gnbMenu.menuName : t(gnbMenu.menuName)) : ''}*/}
                {/*    </span>*/}
                {/*    {gnbMenu.menuName ? <span className="material-icons-round md-18 mr-1">navigate_next</span> : ''}*/}
                {/*    <span className={'menu-main'}>*/}
                {/*        {gnbMenu.subMenuName && (gnbMenu.isCustom ? gnbMenu.subMenuName : t(gnbMenu.subMenuName))}*/}
                {/*    </span>*/}
                {/*</div>*/}
                <div className="app-header-right gap-2">
                    <img src={HEADER_SUB_LOGO} alt="sub logo" />
                    <SettingDot />
                    <NotificationDots />
                    <FullscreenDot />
                    <UserBox />
                    {/*<HeaderRightDrawer />*/}
                </div>
            </div>
        </ReactCSSTransitionGroup>
    );
};

const MainDesc = styled.span`
    font-size: 1rem;
    font-weight: 800;
    color: #262549 !important; ;
`;

export default Header;
